var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-neutral-lighter flex items-center my-xl p-xl text-sm rounded-lg"},[_c('font-awesome-icon',{staticClass:"text-lg text-accent-yellow mr-lg",attrs:{"icon":"info-circle"}}),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }